// ============================================================
// DM-LMS — RequireCompleteProfile Guard
// Wraps the student sidebar routes (not /app/student/profile-setup
// itself, or the redirect would loop). Mirrors the API's
// checkProfileComplete gate on the client, to avoid a flash of the
// dashboard before the server-side gate would reject its calls.
// ============================================================

import { Navigate } from "react-router-dom";
import { useProfile } from "../../contexts/ProfileContext.js";

interface RequireCompleteProfileProps {
  children: React.ReactNode;
}

export default function RequireCompleteProfile({ children }: RequireCompleteProfileProps) {
  const { profile, isLoading } = useProfile<"student">();

  // Loading state avoids a flicker of the dashboard before we know whether
  // to redirect. A fetch error fails open — the server-side gate remains
  // the real authority, so a transient network error shouldn't lock the
  // student out of the whole app.
  if (isLoading) return <div className="dm-loading">Loading...</div>;

  if (profile && !profile.profileComplete) {
    return <Navigate to="/app/student/profile-setup" replace />;
  }

  return <>{children}</>;
}
